import { SelectionChangedEvent } from "ag-grid-community";
import { RecalProposalSetDtlEntity } from "domain/entity/RecalProposalSet/RecalProposalSetDtlEntity";
import { RecalProposalSetConstant } from "presentation/constant/RecalProposalSet/RecalProposalSetConstant";
import { INITIAL_RECAL_PROPOSAL_SET_DTL_COL_DEF, INITIAL_RECAL_PROPOSAL_SET_DTL_COL_DEF_FOR_SAPT, transferRowData } from "presentation/constant/RecalProposalSet/RecalProposalSetDtlColumnDefinition";
import { useRecalProposalSetVM } from "presentation/hook/RecalProposalSet/useRecalProposalSetVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { RecalProposalSetModel } from "presentation/model/RecalProposalSet/RecalProposalSetModel";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import RecalProposalSetDtlEditPanel from "../RightPanel/RecalProposalSetDtlEditPanel";
const RecalProposalSetDtlTablePanel = ({ recalProposalSetState }: { recalProposalSetState: RecalProposalSetModel }) => {
    const gridRef: any = useRef(null);
    const { selectedDtlRows, isShowDtlAddPanel, isShowDtlEditPanel, isEdit, isAdd } = recalProposalSetState;
    const recalProposalSetVM = useRecalProposalSetVM();
    const messageBarVM = useMessageBarVM();
    const [anainfoState] = useANAInfoTracked();
    const { allowCreate, allowDelete, operatingUnit } = anainfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        recalProposalSetVM.updateSelectedDtlRows(selectedRows);
    }, [recalProposalSetVM])


    const handleRowDoubleClick = useCallback((entity: RecalProposalSetDtlEntity) => {
        if (!isEdit && !isAdd) return;
        recalProposalSetVM.onDtlRowDoubleClick(entity);
    }, [recalProposalSetVM, isAdd, isEdit])

    const handleAddClick = useCallback(() => {
        recalProposalSetVM.onDtlAddRowClick(operatingUnit);
    }, [recalProposalSetVM, operatingUnit])

    const handDelete = useCallback(() => {
        if (selectedDtlRows.length === 0) {
            messageBarVM.showError("Please select a record(s) to delete.");
        }
        recalProposalSetVM.onDtlDtlDeleteClick(selectedDtlRows);
    }, [recalProposalSetVM, messageBarVM, selectedDtlRows]);

    const memoBtns = useMemo(() => {

        const hdrBtns = [];
        allowDelete && ((isAdd || isEdit) && !(isShowDtlAddPanel || isShowDtlEditPanel)) && hdrBtns.push({
            id: 'onDeleteButton',
            icon: 'Icon-trash',
            title: 'Delete'
        })

        return hdrBtns
    }, [allowDelete, isAdd, isEdit, isShowDtlAddPanel, isShowDtlEditPanel])

    const memoRecalProposalSetDtlTable = useMemo(() => {

        return (
            <>
                <TableWrapper>
                    <div id="myDiv">
                        <NbisTable
                            id='recal-proposal-set-dtl-table'
                            isNewColumnSetting={true}
                            headerLabel={RecalProposalSetConstant.Title.DTL_TITLE}
                            columns={(operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? INITIAL_RECAL_PROPOSAL_SET_DTL_COL_DEF_FOR_SAPT : INITIAL_RECAL_PROPOSAL_SET_DTL_COL_DEF}
                            data={transferRowData(recalProposalSetState.tempDtlRows)}
                            showPaginator={false}
                            editable={false}
                            headerActionButtons={memoBtns}
                            onDeleteButton={handDelete}
                            showAddIcon={allowCreate && ((isAdd || isEdit) && !(isShowDtlAddPanel || isShowDtlEditPanel))}
                            onAddClick={handleAddClick}
                            showDeleteButton={false}
                            showReloadIcon={false}
                            showUploadIcon={false}
                            isScrollHighlighted={true}
                            selectionMode={false}
                            isRowHighligted={true}
                            rowSelection={"multiple"}
                            handleSelectionChanged={handleSelectionChange}
                            onRowDoubleClick={(e: any, entity: RecalProposalSetDtlEntity) => handleRowDoubleClick(entity)}
                            gridHeight="customHeight"
                            customHeight="calc(100vh - 90px)"
                            ref={gridRef}
                        />
                    </div>
                </TableWrapper >
            </>
        );
    }, [allowCreate, recalProposalSetState.tempDtlRows, memoBtns, handDelete, isAdd, isEdit, isShowDtlAddPanel, isShowDtlEditPanel, handleAddClick, handleSelectionChange, handleRowDoubleClick, operatingUnit])

    return <>
        <div className={`main-comp-wrapper${(isShowDtlAddPanel || isShowDtlEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={(isShowDtlAddPanel || isShowDtlEditPanel) ? "65%" : "100%"}
                rightSectionWidth={(isShowDtlAddPanel || isShowDtlEditPanel) ? "35%" : "0%"}
                leftChildren={memoRecalProposalSetDtlTable}
                rightChildren={<RecalProposalSetDtlEditPanel />}
            />
            {recalProposalSetState.dtlForceRefresh && <></>}
        </div>
    </>
}

export default memo(RecalProposalSetDtlTablePanel);
